import styled from '@emotion/styled';
import { css } from '@emotion/react';

import MEDIA_QUERY_V2 from '../../../styles/emotion/mediaQueryV2';
import SPACING from '../../../styles/emotion/spacing';

import {
  CloseOnboardingContainer,
  Container,
  SectionsContainer,
  SectionsContent,
} from '../OnboardContainer/OnboardContainer.styles';
import { ModalV2 } from '../../Modal';
import { ModalDialog, Overlay } from '../../Modal/ModalV2.styles';

export const ModalContainer = styled(ModalV2)<{ fullScreen: boolean }>`
  overflow: auto;
  z-index: 501 !important;

  ${Overlay} {
    z-index: 501 !important;
  }

  ${({ fullScreen }) =>
    fullScreen
      ? css`
          ${ModalDialog} {
            margin: 0;
            height: 100%;
            min-height: 100vh;
            width: 100vw;
          }
        `
      : css`
          ${CloseOnboardingContainer}, ${Container} {
            height: fit-content;
            background-color: transparent;
          }
          ${SectionsContainer} {
            padding: 56px ${SPACING.S24} ${SPACING.LG};
            ${MEDIA_QUERY_V2.DESKTOP} {
              padding: 56px ${SPACING.S48} ${SPACING.XS};
            }
          }
          ${SectionsContent} {
            max-width: 624px;
          }
        `}
`;
